<div class="card">
    <div class="flex items-center justify-between mb-4">
        <div class="font-semibold text-xl">{{ translateServ.dictionary['ACT_HIST_TIT'] }} - {{ viewScopeService.getCurrentCustomerName() }}</div>
    </div>

    <p-progressBar *ngIf="loading" mode="indeterminate"></p-progressBar>

    <div *ngIf="!loading && error" class="text-red-500 font-medium">
        {{ error }}
    </div>

    <div *ngIf="!loading && !error && lastTimeDoneItems.length === 0" class="text-color-secondary">
        No activity data found.
    </div>

    <p-table *ngIf="!loading && !error && lastTimeDoneItems.length > 0"
        [value]="lastTimeDoneItems"
        styleClass="p-datatable-sm"
        responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 40px;"></th>
                <th style="width: 220px;" class="text-left">{{ translateServ.dictionary['STEP_TAB_TIT_Type'] }}</th>
                <th style="width: 110px;" class="text-left">{{ translateServ.dictionary['RECENTLY_DONE'] }}</th>
                <th style="width: 140px;" class="text-left">{{ translateServ.dictionary['MAINT_CS_TIT_PREF_BY'] }}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td class="text-center">
                    <span class="doc-activity-index">{{ item.ID }}</span>
                </td>
                <td>
                    <span class="text-surface-900 dark:text-surface-0 font-medium" dir="auto">{{ item.Descr }}</span>
                </td>
                <td class="font-medium white-space-nowrap">
                    {{ item.LastDate | date:'dd/MM/yyyy' }}
                </td>
                <td>
                    <span class="font-medium" dir="auto">{{ item.ByUser || '-' }}</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>